/**
 * The dashboards under /support-dashboard, each with the permission that governs it.
 *
 * Single source of truth for both the picker's tiles and the router's routes. They used to be
 * separate lists, which is how a tile could be hidden while its route stayed reachable by URL.
 */
export const SUPPORT_DASHBOARDS = [
  {
    route: 'allowed-doctors',
    labelKey: 'pages.opsDashboard.tiles.allowedDoctors',
    isPermitted: permissions => permissions.opsDashboardAllowedDoctors
  },
  {
    route: 'doctors-and-members',
    labelKey: 'pages.opsDashboard.tiles.doctors',
    isPermitted: permissions => permissions.opsDashboardPractices
  },
  {
    route: 'patients',
    labelKey: 'pages.opsDashboard.tiles.patients',
    isPermitted: permissions => permissions.opsDashboardPatients
  },
  {
    route: 'release-notes',
    labelKey: 'pages.opsDashboard.tiles.releaseNotes',
    isPermitted: permissions => permissions.opsDashboardReleaseNotes
  },
  {
    route: 'stats',
    labelKey: 'pages.opsDashboard.tiles.stats',
    isPermitted: permissions => permissions.opsDashboardStats
  },
  {
    route: 'promotions',
    labelKey: 'pages.opsDashboard.tiles.promotions',
    isPermitted: permissions => permissions.opsDashboardPromotions
  },
  {
    route: 'announcements',
    labelKey: 'pages.opsDashboard.tiles.announcements',
    isPermitted: permissions => permissions.opsDashboardAnnouncements
  },
  {
    route: 'scripts',
    labelKey: 'pages.opsDashboard.tiles.playground',
    isPermitted: permissions => permissions.opsActions.playgroundTasks
  },
  {
    route: 'ops-actions',
    labelKey: 'pages.opsDashboard.tiles.opsActions',
    // `opsActions` is a dict of individual actions, so testing the dict itself is always true.
    // This mirrors how OpsActions.jsx decides whether it has anything to render.
    isPermitted: permissions => permissions.opsActions.all || permissions.opsActions.copyPatients
  },
  {
    route: 'billing',
    labelKey: 'pages.opsDashboard.tiles.billing',
    isPermitted: permissions => permissions.opsDashboardBilling
  },
  {
    route: 'scope-orders',
    labelKey: 'pages.opsDashboard.tiles.scopeOrders',
    isPermitted: permissions => permissions.opsDashboardScopeOrders
  },
  {
    route: 'articles',
    labelKey: 'pages.opsDashboard.tiles.articles',
    isPermitted: permissions => permissions.opsDashboardArticles
  },
  {
    route: 'system-automations',
    labelKey: 'pages.opsDashboard.tiles.systemAutomations',
    isPermitted: permissions => permissions.opsDashboardSystemAutomations
  },
  {
    route: 'hi-practices',
    labelKey: 'pages.opsDashboard.tiles.hiPractices',
    isPermitted: permissions => permissions.opsDashboardHIPractices
  }
]

export const permittedDashboards = permissions =>
  SUPPORT_DASHBOARDS.filter(dashboard => !!dashboard.isPermitted(permissions))

export const canOpenDashboard = (permissions, route) =>
  permittedDashboards(permissions).some(dashboard => dashboard.route === route)
